import { FC, useState } from 'react'

import { PatientModel } from '@models/patient'

import { Button } from '@components/Button'

import { PatientFormDrawer } from '@modules/patients/components/PatientFormDrawer'
import { PermissionsControl } from '@modules/permissions'

import { PermissionEnum } from '@/constants/permission'
import { PatientFormShape } from '@modules/patients/components/PatientForm'
import FormUtil from '@/utils/formUtil'
import { PatientsAPI, PayloadCreatePatient } from '@api/patientsAPI'
import { FormattedMessage } from 'react-intl'

type Props = {
  onCreated: (patient: PatientModel) => void
}

const QueueNumberPatientCreateButton: FC<Props> = ({ onCreated }) => {
  const [isShowPatientDrawer, setIsShowPatientDrawer] = useState<boolean>(false)

  const handleCreatePatient = async (values: PatientFormShape) => {
    const payload = FormUtil.parseValues<PayloadCreatePatient>(values)
    const response = await PatientsAPI.create(payload)
    if (response.data?.patient) {
      onCreated(response.data.patient)
    }
    setIsShowPatientDrawer(false)
  }

  return (
    <PermissionsControl allow={PermissionEnum.PATIENT_CREATE}>
      <Button
        variant="icon"
        theme="primary"
        onClick={() => setIsShowPatientDrawer(true)}
      >
        <i className="fa-solid fa-plus" />
      </Button>

      <PatientFormDrawer
        isShow={isShowPatientDrawer}
        title={<FormattedMessage id="patient.create" />}
        onSubmit={handleCreatePatient}
        onClose={() => setIsShowPatientDrawer(false)}
      />
    </PermissionsControl>
  )
}

export default QueueNumberPatientCreateButton
